import { type TooltipItem, type ChartOptions } from "chart.js";

import { debouncedResize } from "@features/sales-v3/utils/chart";

import { chartTooltip } from "./chart-tooltip";
import { todayMarkerAnnotation } from "./plugins/today-marker-annotation";

export function getTrackingChartOptions(
  formatUserCurrency: (val: number) => string,
  timezone: string,
): ChartOptions<"line"> {
  return {
    parsing: false,
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",

      intersect: false,
    },
    // on resize, reload the annotations
    onResize: debouncedResize,
    plugins: {
      title: {
        display: true,
        align: "start",
        font: { size: 18 },
      },
      legend: { display: false },
      annotation: {
        annotations: {
          ...todayMarkerAnnotation(timezone),
        },
      },
      tooltip: {
        external: (ctx: any) => chartTooltip(ctx, formatUserCurrency),
        mode: "nearest",
        enabled: false,
        itemSort: (a: TooltipItem<"line">, b: TooltipItem<"line">) =>
          b.datasetIndex - a.datasetIndex,
      },
    },
    scales: {
      x: {
        axis: "x",
        grid: {
          drawOnChartArea: true,
          drawBorder: false,
          drawTicks: false,
        },
        ticks: {
          padding: 20,
          maxRotation: 0,
          autoSkip: true,
          font: {
            family: "Commons Pro",
            size: 13,
          },
        },
      },
      y: {
        ticks: {
          padding: 24,
          font: {
            family: "Commons Pro Mono",
            size: 11,
          },
          maxTicksLimit: 6,
          callback: (tickValue) => formatUserCurrency(Number(tickValue)),
        },
        beginAtZero: true,
        display: true,
        position: "left",
        grid: {
          drawTicks: false,
          drawBorder: false,
          drawOnChartArea: true,
        },
      },
    },
  };
}
